controllers.controller('WireTransferController', [
    '$scope', '$state', 'constants', 'LocaleService', 'Storage',
    function ($scope, $state, Const, LocaleService, Storage) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.paymentMethods = Storage.get('paymentMethods') || [];

        $scope.defaultBankDetails = Const.wiretransferDetails || {
            beneficiary_name: '',
            beneficiary_address: '',
            beneficiary_bank: '',
            bank_address: '',
            beneficiary_account_number: '',
            beneficiary_iban: '',
            swift: '',
            comments: ''
        };

    }]);
